import Vue from 'vue'
import App from './App.vue'

import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import Api from './api/index.js';
Vue.prototype.$api = Api;

Vue.config.productionTip = false

import Axios from 'axios'
Vue.prototype.$axios = Axios

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

//引入MD5加密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

// 引用通用工具类
import util from "./utils/util";

Vue.prototype.$util = util;


import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
